export default "__VITE_PUBLIC_ASSET__5619ddf9__"